module.exports = {
    dev: {
        host: 'localhost',
        // host: '172.27.4.70',
        ajaxUrl: 'https://uat.jinjiwo.com:25013/fund-business/',
        // ajaxUrl: 'https://uat.jinjiwo.com:25013/lsj-business/',
        // ajaxUrl: 'https://dev.jinjiwo.com:25013/fund-business/',
        // ajaxUrl: 'https://rpdtwww.jinjiwo.com:25013/fund-business/',
        // ajaxUrl: 'http://172.27.4.136:8080/',//何增
        // ajaxUrl: 'http://172.27.4.225:8081/',//泉水
        // ajaxUrl: 'http://172.27.4.56:8081/',//裴迪
        // ajaxUrl: 'http://172.27.4.116:8080/',//士辉
        // ajaxUrl: 'http://172.27.4.127:8080/', //田刚
        // ajaxUrl: 'http://172.27.4.147:8080/', //中正
        platformUrl: 'https://uatauth.jinjiwo.com:2542/',
        // platformUrl: 'https://devauth.jinjiwo.com:6391/',
        // platformUrl: 'https://rpdtauth.jinjiwo.com:9443/',
        backIndexUrl:'http://localhost:8081/'
    },
    uat: {
        ajaxUrl: '/fund-business/',
        platformUrl: 'https://uatauth.jinjiwo.com:2542/',
        // platformUrl: 'https://devauth.jinjiwo.com:6391/',
        backIndexUrl:'https://uat.jinjiwo.com:25013/'
        // backIndexUrl:'https://dev.jinjiwo.com:25013/'
    },
    pdt: {
        ajaxUrl: '/fund-business/',
        // 预生产环境
        // platformUrl: 'https://rpdtauth.jinjiwo.com:9443/',
        // backIndexUrl:'https://rpdtwww.jinjiwo.com/'
        // 生产环境
        platformUrl: 'https://auth.jinjiwo.com:9443/',
        backIndexUrl:'https://www.jinjiwo.com/'
    }
};



//////////////////
// WEBPACK FOOTER
// ./config/url.config.js
// module id = 8DLv
// module chunks = 1 2 3 4 5 6 7 8